/**
 * Shared currency formatting utility for Botswana Pula (BWP).
 * Produces format: "P 12,000.00"
 *   - P prefix with a space
 *   - Thousand separators (commas)
 *   - Exactly 2 decimal places
 */

const pulaFormatter = new Intl.NumberFormat('en-BW', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats a numeric value as Botswana Pula.
 * @param {number|string} value - The monetary value to format.
 * @returns {string} Formatted string, e.g. "P 12,000.00"
 */
export const formatCurrency = (value) => {
  const num = Number(value);
  const safe = isNaN(num) ? 0 : num;
  return `P ${pulaFormatter.format(safe)}`;
};

/**
 * Formats a numeric value as Pula without the P prefix.
 * Useful for table columns that already show "Amount (P)" in the header.
 * @param {number|string} value - The monetary value.
 * @returns {string} Formatted number string, e.g. "12,000.00"
 */
export const formatNumber = (value) => {
  const num = Number(value);
  const safe = isNaN(num) ? 0 : num;
  return pulaFormatter.format(safe);
};

export default formatCurrency;
